import React, { VFC } from 'react';

import { Text } from 'mintel-react-ui';

import { AccessListItem, TranslatableString } from '/types';

import styles from './AccessList.scss';

type AccessListProps = {
  title: TranslatableString;
  accessItems: AccessListItem[];
};

const AccessList: VFC<AccessListProps> = ({ title, accessItems }) => (
  <table className={styles.table}>
    <thead>
      <tr>
        <td colSpan={2}>
          <Text.Body darkBg>
            <strong>{title}</strong>
          </Text.Body>
        </td>
      </tr>
    </thead>
    <tbody>
      {accessItems.map(({ key, name, company }: AccessListItem) => (
        <tr key={key}>
          <td>
            <Text.Body darkBg>{name}</Text.Body>
          </td>
          <td>
            <Text.Body darkBg>{company}</Text.Body>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default AccessList;
